module.exports = __webpack_public_path__ + "assets/img/doc_developer_code.a9b409c4.png";